import React, { Component } from 'react'

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';
import Pagination from 'react-js-pagination';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';

//providers
import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;
import Helper from '../../services/Helper'; var help = Helper;

export default class ServiceRequestList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      all_requests: [],
      current_offset: 0,
      activePage: 1,
      maxItems: 6,
      totalCount: 0,
      selectedId: this.props.selectedId,
      service_ids: this.props.service_ids ? this.props.service_ids : '',
      service_name: this.props.service_name ? this.props.service_name : '',
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  }

  componentDidMount() {
    this.getAllRequests(this.state.current_offset);
    window.addEventListener('_mqt', (e) => {
      if (e && e.detail && e.detail.act_type == "new_service") {
        this.props.serviceChange(e.detail.name)
        this.refreshTable();
      }
 })
  }

  componentWillUnmount() {
    window.removeEventListener('_mqt', (data) => { console.log(data) })
}


  onChangePage(e) {
    this.getAllRequests(this.state.maxItems * (e - 1));
    this.setState({
      activePage: e
    });
  }

  clearUnseenCount() {
    let c = [];
    for (let i of this.state.all_requests) {
      if (!i.seen) {
        c.push(i._id);
      }
    }

    if (c.length) {
      ds.postChangeUnseenCount({
        requests: c
      }, 
      data => {
        this.setState({
          unseen_count: this.state.unseen_count - c.length
        });
      }, 
      err => {})
    }
  }

  getAllRequests(offset, offset_change = 0) {
    ds.getServiceRequests(ls.getUserDetails().hotel_id, this.state.maxItems, offset,
      data => {
        if (data.service && data.service.length) {
          for (let row of data.service) {
            if (row.timestamp) {
              let cell = row.timestamp;
              let x = new Date(cell);
              row.time = x && x != 'Invalid Date' ? x.toLocaleString() : 'Unknown'
              row.date = x && x != 'Invalid Date' ? x.toDateString() : 'Unknown'
            }
          }
        }

        this.setState({
          all_requests: data.service,
          totalCount: data.count

        }, () => {
          this.clearUnseenCount();
        });

        if (!offset_change) {
          let x = this.state.current_offset;
          this.setState({
            current_offset: offset + this.state.maxItems
          });
        }
      }, err => {}, 
      [this.state.service_ids]
    );
  }

  requestAction(action, row) {
    this.setState({
      dialog: {
        open: true,
        head: 'Sure',
        body: `Make the request as ${action}?`,
        actions: [
          <FlatButton
            label="Cancel"
            primary
            onClick={this.closeDialog.bind(this)}
          />,
          <FlatButton
            label="Yes"
            primary
            onClick={() => {
              ds.postProcessServiceRequests({
                request_id: row._id,
                room_id: row.hotel_room_id ? row.hotel_room_id._id : "",
                status: action
              }, data => {
                this.refreshTable();
                this.closeDialog()
              }, err => {
                this.closeDialog()
              })
            }}
          />
        ]
      }
    })
  }

  refreshTable(e) {
    this.getAllRequests(this.state.current_offset - this.state.maxItems > 0 ? this.state.current_offset - this.state.maxItems : 0, 1);
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })
  }

  getMetaLines(meta) {
    let lines = [];
    if (!meta) return lines;
    for (let group of meta) {
      if (!group) continue;
      if (group.items && group.items.length) {
        for (let itemName of group.items) {
          lines.push({ name: itemName, quantity: null });
        }
      } else if (group.name) {
        lines.push({ name: group.name, quantity: group.quantity });
      }
    }
    return lines;
  }

  showMeta(row) {
    let x = [];
    for (let i of this.getMetaLines(row.meta)) {
      x.push(
        <p style={{fontSize: '18px', fontWeight: '300'}}>
          • {i.name}{i.quantity ? `    x${i.quantity}` : ''}
        </p>
      )
    }
    this.setState({
      dialog: {
        head: 'Order Details',
        body: x,
        open: true,
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    })
  }

  render() {
    let pagination;
    pagination = <Pagination
      activePage={this.state.activePage}
      itemsCountPerPage={this.state.maxItems}
      totalItemsCount={this.state.totalCount}
      pageRangeDisplayed={5}
      onChange={this.onChangePage.bind(this)} 
    />

    return (<div>
      <div className="col-sm-12">
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>

        <Table
          height={'50vh'}
          fixedHeader={true}
          fixedFooter={true}
          selectable={false}
          multiSelectable={false}
          style={{ minWidth: 400 }}
          bodyStyle={{ minWidth: 400, overflowX: 'auto' }}
        >
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn tooltip="Room Number">Room Number</TableHeaderColumn>
              {
                window.screen.width >= 650 ? 
                  <TableHeaderColumn tooltip="Requested Date">Time</TableHeaderColumn> 
                : null
              }

              <TableHeaderColumn tooltip="Service Items">
                Service Items
              </TableHeaderColumn> 

              <TableHeaderColumn className="align-center">Action</TableHeaderColumn>
            </TableRow>
          </TableHeader>

          <TableBody
            displayRowCheckbox={false}
            showRowHover={true}
            stripedRows={false}
          >
            {
              this.state.all_requests.map((row, index) => {
                let metaLines = this.getMetaLines(row.meta);
                return (
                <TableRow key={index}>
                  <TableRowColumn >
                    <div style={{ fontSize: "2rem" }}>{row.hotel_room_id ? row.hotel_room_id.name : 'NA'}</div>
                    {
                      window.screen.width < 650 ? 
                        <div style={{ fontSize: "0.7rem", paddingLeft: "0.3rem", paddingTop: "0.3rem", color: "gray" }}>{row.time}</div> 
                      : null
                    }
                  </TableRowColumn>

                  {
                    window.screen.width >= 650 ? 
                      <TableRowColumn>{row.time}</TableRowColumn> 
                    : null
                  }

                  <TableRowColumn >
                    {
                      metaLines.length ?
                        <div style={{ fontSize: "0.7rem", paddingLeft: "0.3rem", paddingTop: "0.3rem" }}>
                          {
                            metaLines.map((item, index1) => {
                              return <li key={index1+'___Some___Random__Thing'} className="font-1-2rem mb-0-4rem">
                                { item.name }{item.quantity ? ` x${item.quantity}` : ''}
                              </li>
                            })
                          }
                        </div>

                      : 'NA'
                    }
                  </TableRowColumn>

                  <TableHeaderColumn className="v-center">
                    {
                      row.status == "Pending" ?
                        <div className="align-center w-100">
                          <i onClick={this.requestAction.bind(this, 'Accepted', row)} style={{ fontSize: "3rem", cursor: 'pointer', color:'#3abcd4'}} className="material-icons">check_circle</i>

                          <i onClick={this.requestAction.bind(this, 'Rejected', row)} style={{ fontSize: "3rem", cursor: 'pointer'}} className="material-icons warn-fg">cancel</i>

                          {
                            metaLines.length ?
                              <i onClick={this.showMeta.bind(this, row)} style={{ fontSize: "3rem", cursor: 'pointer', color:'#3abcd4'}} className="material-icons">visibility</i>
                            : null
                          }
                        </div> 
                      :
                      <div className="align-center w-100">
                        <span className={row.status == 'Accepted' ? 'secondary-bg white-fg p-4px' : row.status == 'Rejected' ? 'warn-bg white-fg p-4px' : ''}>{row.status}</span>
                      </div>
                    }
                  </TableHeaderColumn>
                </TableRow>
              )})
            }
          </TableBody>

          <TableFooter>
            <TableRow>
              <TableRowColumn colSpan="2" style={{ textAlign: 'left' }}>
                {pagination}
              </TableRowColumn>
            </TableRow>
          </TableFooter>
        </Table>
      </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/services/ServiceRequestList.js